import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { CreateDesignFolderDocument } from './create.generated';

export const useCreateDesignFolder = (
  options: ApiOptions<typeof CreateDesignFolderDocument> = {},
) => {
  const { t } = useTranslation();
  return useMutation(CreateDesignFolderDocument, {
    ...useNotifications(CreateDesignFolderDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
      success: t('api.design_folders.create_success'),
    }),
    ...options,
  });
};
